import React from 'react'
import { CreditCardItem } from '@features/billing/CreditCardBox/index'
import { Button } from '@components/Basic/ButtonNbe'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@app/dataTracking'
import { makePricingTrackingStep } from '@app/dataTracking/utils'
import { useLocation } from 'react-router-dom'
import { MdMode } from 'react-icons/md'

interface Props {
  card: CreditCardItem
  onEditCardRequest: () => void
}

const CardDetailsStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  width: 100%;
  background-color: #ece8e8;
  border-radius: 6px;

  p {
    margin: 0 1rem;
    font-size: 1rem;
    color: #777b80;
  }

  img {
    width: 60px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 2rem;
`

const CardDetailsWrapper = styled.div`
  flex: 1;
  max-width: 420px;
`

const ImgBox = styled.div`
  width: 30%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const CardDetails: React.FC<Props> = ({ card, onEditCardRequest }) => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <Wrapper>
      <CardDetailsWrapper>
        <CardDetailsStyled>
          {card.logoUri && <img src={card.logoUri} alt='card-logo' />}
          <div>
            {card.fullName ? <p>{card.fullName}</p> : null}
            <p>
              {card.number} - {card.expiration}
            </p>
          </div>
        </CardDetailsStyled>

        <ButtonWrapper>
          <MdMode size={24} color={'#41a6dc'} />
          <Button
            style={{ margin: '0', padding: '1rem 0.5rem' }}
            onClick={() => {
              trackEvent({
                eventName: 'CreditCardChangeStarted',
                feature: 'Pricing',
                step: makePricingTrackingStep(location.pathname),
              })

              onEditCardRequest()
            }}
            $variant={'link-primary'}
            $size={'large'}
          >
            {t('billing.payment.editCard')}
          </Button>
        </ButtonWrapper>
      </CardDetailsWrapper>
      <ImgBox />

      {/* <div style={{ width: '270px' }}>
        <Button
          onClick={() => {
            trackEvent({
              eventName: 'CreditCardChangeStarted',
              feature: 'Pricing',
              step: makePricingTrackingStep(location.pathname),
            })

            onEditCardRequest()
          }}
          $fluid
          $variant={'blue'}
          $size={'large'}
        >
          {t('billing.payment.editCard')}
        </Button>
      </div> */}
    </Wrapper>
  )
}
